import React, { Suspense, useEffect, useState } from 'react'
import NavbarLayout from '../components/NavbarLayout'
import { Outlet } from 'react-router'

const PageLayout = () => {
    const [isLogin, setIsLogin] = useState<boolean>(true);
    useEffect(() => {
        if (sessionStorage.getItem("isLogin")) {
            setTimeout(() => {
                setIsLogin(false);
                sessionStorage.removeItem("isLogin");
            }, 2600)
        }
    }, [])

    return (
        <> {
            sessionStorage.getItem("isLogin") && isLogin ?
                <div className="loader-cls w-100 vh-100">
                    <div className="d-flex justify-content-center align-items-center h-100" >
                        <img src="/images/loader/login_loader.gif" style={{ width: "25rem", height: "25rem" }} />
                    </div>
                </div>
                :
                <NavbarLayout>
                    <Suspense fallback={<div className="d-flex justify-content-center align-items-center  crt-loader" style={{ width: "100vw", height: "100vh" }}>
                        <img src="/images/loader/content_loader.gif" />
                    </div>} >
                        <Outlet />
                    </Suspense>
                </NavbarLayout>}
        </>
    )
}

export default PageLayout